import { Injectable } from '@angular/core';
import { ExcelColumn } from 'app/modules/common/entities/leave-import/template.model';
import { ExcelColumnTableRow } from '../leave-import-excel/leave-import-excel.component';

@Injectable({
    providedIn: 'root'
})
export class ExcelColumnsService {

    /*
    * Storing excel column as a global state due to performance issues
    */
    private _excelColumnViewData: ExcelColumnTableRow[] = [];
    public get excelColumnViewData(): ExcelColumnTableRow[] {
        return this._excelColumnViewData;
    }


    constructor() { }


    /**
     * Clear all column values. Since the work load is high, this function is made async
     */
    public clearAllValues() {
        this._excelColumnViewData.forEach(ele => ele.campo = null);
    }


    /**
     * Clear single column value in Excel column table and update consumer values
     * @param row Excel column table row
     */
    public clearSingleValue(row: ExcelColumnTableRow) {
        row.campo = null;
    }


    //#region DATA CONVERTION

    /**
    * Feed normal excel column table data to view data
    */
    public feedExcelData(columnData: ExcelColumn[]) {
        this._excelColumnViewData = this.convertToViewData(columnData);
    }


    /**
     * Convert excel column data into view data
     */
    private convertToViewData(columnData: ExcelColumn[]): ExcelColumnTableRow[] {
        const tempDataSource: ExcelColumnTableRow[] = [];

        for (let index = 1; index <= 256; index++) {
            const c = this.getChar(index);

            // get the value given by consumer
            const consumerValue = columnData.filter(x => x.columna === index)[0]?.campo;

            tempDataSource.push({
                columna: index,
                campo: consumerValue,
                label: c,
            });
        }

        return tempDataSource;
    }


    /**
     * Convert the index into column label
     * @param index This value should be between 1 - 256
     * @returns Single or double character relavant to the index
     */
    private getChar(index: number) {
        const remainder = index % 26;
        let c = remainder === 0 ? "Z" : String.fromCharCode(64 + remainder);

        const quat = Math.floor((index - 1) / 26);
        if (quat > 0) {
            c = String.fromCharCode(64 + quat) + c;
        }

        return c;
    }


    /**
     * Get excel data
     */
    public getExcelData(): ExcelColumn[] {
        const columnData = this.convertIntoColumnData(this._excelColumnViewData);
        return columnData;
    }


    /**
     * Convert view data into excel column data
     */
    private convertIntoColumnData(viewData: ExcelColumnTableRow[]): ExcelColumn[] {

        const columnData = viewData
            .filter(x => x.campo && x.campo !== null)
            .map(x => ({ columna: x.columna, campo: x.campo }));

        return columnData;

    }

    //#endregion

}
